<template>
    <div class="card shadow-sm">
        <div class="card-body text-left">
            <h5 v-if="title" class="card-title">{{title}}</h5>
            <slot></slot>
            <!-- <hr v-if="this.$slots.footer"/> -->
        </div>
        <div v-if="this.$slots.footer" class="card-footer text-left bg-white">
            <slot name="footer">
                <!-- Footer Content will load here -->
            </slot>
        </div>
    </div>
</template>
<script>
export default {
    name: "Card",
    props: ['title'],
    data: function() {
        return {}
    }
}
</script>
<style lang="scss">
    .footer {
        border-top: 1px solid;
    }
</style>
